var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceiptBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    fill: "#5165FB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 43.95V4.05L9 7.05L12 4.05L15 7.05L18 4.05L21 7.05L24 4.05L27 7.05L30 4.05L33 7.05L36 4.05L39 7.05L42 4.05V43.95L39 40.95L36 43.95L33 40.95L30 43.95L27 40.95L24 43.95L21 40.95L18 43.95L15 40.95L12 43.95L9 40.95ZM11.85 33.2H36.35V30.2H11.85ZM11.85 25.5H36.35V22.5H11.85ZM11.85 17.75H36.35V14.75H11.85ZM9 38.9H39V9.1H9ZM9 9.1V38.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptBlue);
export default __webpack_public_path__ + "static/media/receipt_blue.1860a58113f78cff198d8e3baa8af71b.svg";
export { ForwardRef as ReactComponent };